import React, { useState } from "react";
import { MainInput } from "../../../mainComponent/mainInput";
import { MainButtonInput } from "../../../mainComponent/mainButtonInput";
import { useRecoilState } from "recoil";
import MedicineApi from "../../../services/MedicineApi";
import { setDoctorMedicine } from "../../../recoil/atom/setDoctorMedicine";
import { validateForm } from "../../Dashboard-card/validateForm";

const InsertMedicine = (props) => {
    const { doctorId } = props
    const [medicine, setMedicine] = useState([]);
    const [errors, setErrors] = useState({});
    const [getMedicine, setGetMedicine] = useRecoilState(setDoctorMedicine);
    const { insertMedicine } = MedicineApi()

    function handleChange(event) {
        const { name, value } = event.target;
        setMedicine(prevInput => {
            return {
                ...prevInput,
                [name]: value
            }
        })
    }

    const Save = (e) => {
        e.preventDefault();
        const validation = validateForm({
            medicine
        });

        if (!validation.formIsValid) {
            setErrors(validation.errors);
            return;
        }
        const bodyData = {
            doctorId: doctorId,
            medicineName: medicine.medicineName,
            mg: medicine.mg
        }
        insertMedicine(doctorId, bodyData)
            .then((res) => {
                setGetMedicine(getMedicine.concat(res))
            });
        props.onSubmit()
    }

    return (
        <div className="width_100">
            <form onSubmit={Save}>
                <div className="form-group">
                    <label className="font_weight">Medicine Name</label>
                    <MainInput
                        type="text"
                        name="medicineName"
                        onChange={handleChange}
                        value={medicine.name}
                        placeholder="Medicine name">
                    </MainInput>
                    {errors.medicineName && <div className="validation mb-1">{errors.medicineName}</div>}
                </div>

                <label className="font_weight">Mg</label>
                <MainInput
                    name="mg"
                    value={medicine.mg}
                    onChange={handleChange}
                    placeholder="Mg">
                </MainInput>
                {errors.mg && <div className="validation">{errors.mg}</div>}

                <div className="mt-5 text-center">
                    <MainButtonInput value="Save" />
                </div>
            </form >
        </div >
    );
};
export { InsertMedicine }
